<template>
  <div>
    <div class="footer-box">
      <span>加工厂签章:</span>
      <span class="m-l-200">
        制表：&nbsp;&nbsp;
        <span class="footer-line">{{createByName}} {{
          createDate ? $utils.dateFormat(new Date(createDate), "/") : ""
        }}</span>
      </span>
      <span class="m-l-5" style="margin-left: 70px;">
        审批1：
        <span class="footer-line">{{businessReplyName}} {{
          businessReplyDate
            ? $utils.dateFormat(new Date(businessReplyDate), "/")
            : ""
        }}</span>
      </span>
      <span class="m-l-5" style="margin-left: 30px;">
        审批2：
        <span class="footer-line">{{productManagerReplyName}} {{
          productManagerReplyDate
            ? $utils.dateFormat(new Date(productManagerReplyDate), "/")
            : ""
        }}</span>
      </span>
    </div>
    <div class="footer-box">
      <span class="m-l-250">统计：&nbsp;&nbsp;
        <span class="footer-line">{{statisticalExaminerReplyName}} {{
          statisticalExaminerReplyDate
            ? $utils.dateFormat(new Date(statisticalExaminerReplyDate), "/")
            : ""
        }}</span>
      </span>
      <span class="m-l-5">
        供应链负责人审批：
        <span class="footer-line"></span>
      </span>
      <span class="m-l-5">
        回复时间：
        <span class="footer-line"></span>
      </span>
      <span>&nbsp;</span>
      <span>&nbsp;</span>
    </div>
    <!-- <div class="footer-box">
      <span>&nbsp;</span>
      <span>&nbsp;</span>
      <span>&nbsp;</span>
    </div> -->
  </div>

  <!-- <div class="container">
    <div class="footer-box">
      <span>赫基:</span>
      <span class="m-l-30" style="margin-left: 35px">
        制表人：&nbsp;&nbsp;
        <span class="footer-line">{{ createByName }}</span>
      </span>
      <span class="m-l-30">
        时间：&nbsp;&nbsp;
        <span class="footer-line">{{
          createDate ? $utils.dateFormat(new Date(createDate), "/") : ""
        }}</span>
      </span>
      <span class="m-l-30">
        审批1：
        <span class="footer-line">{{businessReplyName}}</span>
        时间：
        <span class="footer-line">{{
          businessReplyDate
            ? $utils.dateFormat(new Date(businessReplyDate), "/")
            : ""
        }}</span>
      </span>
      <span class="m-l-30">
        审批2：
        <span class="footer-line">{{ productManagerReplyName }}</span>
        时间：
        <span class="footer-line">{{
          productManagerReplyDate
            ? $utils.dateFormat(new Date(productManagerReplyDate), "/")
            : ""
        }}</span>
      </span>
      <span></span>
    </div>
    <div class="footer-box">
      <span style="margin-left: 65px">
        统计：
        <span class="footer-line">{{ statisticalExaminerReplyName }}</span>
        时间：
        <span class="footer-line">{{
          statisticalExaminerReplyDate
            ? $utils.dateFormat(new Date(statisticalExaminerReplyDate), "/")
            : ""
        }}</span>
      </span>
      <span class="m-l-250">
        供应链负责人审批：
        <span class="footer-line"></span>
      </span>
      <span>
        时间：
        <span class="footer-line"></span>
      </span>
      <span>&nbsp;</span>
    </div>
    <p class="line"></p>
    <div class="footer-box">
      <span>加工厂:</span>
      <span class="m-l-30" style="margin-left: 25px">
        回复时间：&nbsp;&nbsp;
        <span class="footer-line"></span>
      </span>
      <span class="m-l-30">
        加工厂盖章：
        <span class="footer-line"></span>
      </span>
    </div>
  </div> -->
</template>

<script>
export default {
  name: "print-footer",
  props: {
    createByName: {
      type: String,
      default: "",
    },
    statisticalExaminerReplyName: {
      type: String,
      default: "",
    },
    businessReplyName: {
      type: String,
      default: "",
    },
    productManagerReplyName: {
      type: String,
      default: "",
    },
    createDate: {
      type: String,
      default: "",
    },
    productManagerReplyDate: {
      type: String,
      default: "",
    },
    businessReplyDate: {
      type: String,
      default: "",
    },
    statisticalExaminerReplyDate: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
/* .container {
  padding-top: 20px;
}
.footer-box {
  margin-bottom: 10px;
  font-size: 12px;
}
.m-l-250 {
  margin-left: 50px;
}
.m-l-200 {
  margin-left: 50px;
}
.footer-line {
  width: 65px;
  display: inline-block;
  border-bottom: 1px solid #666;
}
.empty {
  margin-left: 10px;
}
.m-l-30 {
  margin-left: 10px;
}
.line {
  margin-bottom: 5px;
  margin-top: 2px;
  border-bottom: 1px dashed #ccc;
} */
.footer-box {
  padding-top: 30px;
}
.m-l-250 {
  margin-left: 190px;
}
.m-l-200 {
  margin-left: 115px;
}
.footer-line {
  width: 155px;
  display: inline-block;
  border-bottom: 1px solid #000;
}
.empty {
  margin-left: 82px;
}
.m-l-5 {
  margin-left: 10px;
}
</style>